import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`Magento_Staging module is used for setting up, previewing and managing future store updates.`}</p>
    <h2 {...{
      "id": "dependencies"
    }}>{`Dependencies`}</h2>
    <p>{`The `}<strong parentName="p">{`Magento_Staging`}</strong>{` is dependent on the following modules:`}</p>
    <ul>
      <li parentName="ul">{`Magento_Ui`}</li>
    </ul>
    <h2 {...{
      "id": "extension-points"
    }}>{`Extension points`}</h2>
    <p>{`Magento_Staging module have configured timeline view that simplify representation of updates. Configuration of
timeline is present in view/adminhtml/ui_component/staging_update_grid.xml file. Difference between simple grid is
in next components declaration:`}</p>
    <ul>
      <li parentName="ul">{`listingToolbar`}
        <ul parentName="li">
          <li parentName="ul">{`template - overloaded template to provide switcher between grid and timeline, legend for timeline.`}</li>
          <li parentName="ul">{`updateTypes - path to status column that provide data for legend`}</li>
        </ul>
      </li>
      <li parentName="ul">{`columns`}
        <ul parentName="li">
          <li parentName="ul">{`component - timeline component tht extends listing.`}</li>
          <li parentName="ul">{`recordTmpl - overloaded template for timeline records.`}</li>
          <li parentName="ul">{`detailsTmpl - template for tooltip that provide details about updates.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`status column`}
        <ul parentName="li">
          <li parentName="ul">{`component - extends selection column, sets class based on value.`}</li>
          <li parentName="ul">{`updateTypesMap - array that contains bounded classes and values.`}</li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "precautions"
    }}>{`Precautions`}</h2>
    <ul>
      <li parentName="ul">{`To avoid mixed content and to work properly, Staging Site Preview feature requires both Storefront and Admin area to be under the same protocol (http or https).`}</li>
    </ul>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 101.2.7.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      